import React, { useEffect, useRef, useState } from 'react';
import { Palette, RotateCcw } from 'lucide-react';
import { toast } from '../../hooks/use-toast';
import api from '../../services/api';
import { deptColor } from './displayHelpers';

export const DeptColorEditor = ({ colors, onSaved }) => {
  const [depts, setDepts] = useState([]);
  const [draft, setDraft] = useState(colors);
  const timer = useRef(null);
  useEffect(() => { api.get('/api/clock/display-link/departments').then((r) => setDepts(r.data)).catch(() => {}); }, []);

  const save = (next) => {
    setDraft(next);
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try { onSaved((await api.put('/api/clock/display-link/dept-colors', { colors: next })).data); }
      catch { toast({ title: 'Could not save colour', variant: 'destructive' }); }
    }, 500);
  };
  const setOne = (dept, v) => save({ ...draft, [dept]: v });
  const reset = (dept) => { const n = { ...draft }; delete n[dept]; save(n); };
  colors = draft;

  if (!depts.length) return null;
  return (
    <div className="border-t pt-3 space-y-1.5" data-testid="display-dept-colors">
      <p className="flex items-center gap-1.5 text-xs font-semibold text-gray-700"><Palette className="h-3.5 w-3.5" /> Department colours</p>
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 max-h-40 overflow-y-auto pr-1">
        {depts.map((dept) => (
          <label key={dept} className="flex items-center gap-1.5 text-[11px] text-gray-700" data-testid={`dept-color-row-${dept}`}>
            <input type="color" value={deptColor(dept, colors)} onChange={(e) => setOne(dept, e.target.value)}
              className="h-5 w-6 cursor-pointer rounded border-0 bg-transparent p-0" data-testid={`dept-color-input-${dept}`} />
            <span className="truncate flex-1">{dept}</span>
            {colors[dept] && (
              <button type="button" onClick={() => reset(dept)} title="Back to automatic" className="text-gray-400 hover:text-gray-700" data-testid={`dept-color-reset-${dept}`}>
                <RotateCcw className="h-3 w-3" />
              </button>
            )}
          </label>
        ))}
      </div>
    </div>
  );
};
